import { useRootStore } from 'src/new_arch/providers/RootStoreProvider';

const useNavigationPanelStore = () => useRootStore().navigationPanelStore;

export default useNavigationPanelStore;
